import React, { useState } from 'react'
import { css } from 'styled-components'

import Text from 'components/common/Text'
import { artefactColors, Color } from 'constants/color'

import * as Styles from './styles'

import { choiceOptionMap } from '../constants'
import DotPulseLoader from '../DotPulseLoader'
import MathJaxComponent from '../MathJaxComponent'

const MotionButton = props => {
    const {
        children,
        textStyles,
        motionButtonStyles,
        onClick,
        loaderColor,
        withLoader = true,
        ...rest
    } = props
    const [loading, setLoading] = useState(false)
    const buttonProps = {
        $loading: loading,
        whileTap: { scale: 0.9 },
        onClick: () => {
            onClick()
            withLoader && setLoading(true)
        },
        $css: motionButtonStyles,
        ...rest,
    }

    return (
        <Styles.Button {...buttonProps}>
            {loading ? (
                <DotPulseLoader loaderColor={loaderColor} />
            ) : (
                <Text color={Color.white} level="5" css={textStyles}>
                    {children}
                </Text>
            )}
        </Styles.Button>
    )
}

export default MotionButton

export const QuizStartButton = ({ onClick }) => {
    return (
        <Styles.StartButtonWrapper>
            <MotionButton onClick={onClick}>Start the Quiz</MotionButton>
        </Styles.StartButtonWrapper>
    )
}

export const QuizStopButton = ({ onClick }) => {
    return (
        <Styles.StopButtonWrapper>
            <MotionButton onClick={onClick}>End Quiz</MotionButton>
        </Styles.StopButtonWrapper>
    )
}

const { QuizChoice } = Styles

export const QuizChoiceButton = ({ content, option, onClick, isSelected }) => {
    const tap = { scale: 0.99 }
    return (
        <QuizChoice.Area
            whileTap={tap}
            onClick={onClick}
            isSelected={isSelected}
        >
            <QuizChoice.Option>
                <Text bold={false}>{choiceOptionMap[option]}</Text>
            </QuizChoice.Option>
            <QuizChoice.Content>
                <Text bold={false}>
                    <MathJaxComponent text={content} />
                </Text>
            </QuizChoice.Content>
        </QuizChoice.Area>
    )
}

export const NextQuestionButton = ({ onClick }) => {
    const textStyles = css`
        font-size: 16px;
        color: rgba(0, 0, 8, 0.8);
    `

    const motionButtonStyles = css`
        background: ${Color.white};
        border-radius: 45px;
        padding: 8px 23px;
    `
    return (
        <Styles.NextQuestionButtonWrapper>
            <MotionButton
                onClick={onClick}
                textStyles={textStyles}
                motionButtonStyles={motionButtonStyles}
                loaderColor="#000"
            >
                Next
            </MotionButton>
        </Styles.NextQuestionButtonWrapper>
    )
}

export const SkipQuestionButton = ({ onClick }) => {
    const textStyles = css`
        font-size: 16px;
    `

    const motionButtonStyles = css`
        background: ${artefactColors.quiz};
        border-radius: 45px;
        padding: 8px 23px;
    `
    return (
        <Styles.NextQuestionButtonWrapper>
            <MotionButton
                onClick={onClick}
                textStyles={textStyles}
                motionButtonStyles={motionButtonStyles}
                withLoader={false}
            >
                Skip
            </MotionButton>
        </Styles.NextQuestionButtonWrapper>
    )
}
